import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Navigations />
        <div
          style={{
            borderBottom: "3px solid black",
            textAlign: "center",
            marginTop: "5rem",
          }} 
        >
          <h1 style={{ color: "rgb(118, 102, 223)" }}>Get in Touch</h1>
          <h4 style={{ color: "rgb(118, 102, 223)" }}>
            Send a general message to related to Websites, Mobile Applications
            static Websites and Landing Pages etc...
          </h4>
        </div>
        <section class="py-5">
          <div class="container">
            <h2 class="mb-5 text-center">
              I’m excited to learn about your project. Ready to get started?
            </h2>
            <div class="row justify-content-center">
              <div class="col-md-12 ">
                <div class="form-row">
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Full Name"
                    />
                  </div>
                  <div class="col">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div class="form-row mt-3">
                  <div class="col">
                    <label class="sr-only" for="inlineFormInputGroup">
                      Username
                    </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroup"
                        placeholder="Budget in Dollar"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <select class="form-control mb-3">
                      <option disabled="" selected="">
                        Select product
                      </option>
                      <option>Product 1</option>
                      <option>Product 2</option>
                      <option>Product 3</option>
                    </select>
                  </div>
                </div>
                <form>
                  <label class="sr-only" for="textarea-contacts-01">
                    Write something...
                  </label>
                  <textarea
                    class="form-control mb-3"
                    id="textarea-contacts-01"
                    rows="5"
                    placeholder="Project Details..."
                  ></textarea>
                  <button
                    style={{
                      backgroundColor: "rgb(118, 102, 223)",
                      color: "white",
                    }}
                    class="btn btn-block"
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

Contact.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(Contact);
